module.exports = __webpack_public_path__ + "img/icon-19.1e86c2c4.svg";